"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTypeNumber = void 0;
var isTypeNumber = function (value) {
    return typeof value === "number";
};
exports.isTypeNumber = isTypeNumber;
//# sourceMappingURL=isTypeNumber.js.map